import React, { useState } from 'react';
import CierreCajaModal from './CierreCajaModal';
import TabResumen from './TabResumen';
import TabSueldo from './TabSueldo';
import TabTecnicos from './TabTecnicos';
import TabGastos from './TabGastos';
import TabAjustesFinanzas from './TabAjustesFinanzas';
import { LuLock } from 'react-icons/lu';
import { CONTENEDOR, PantallaHeader, BotonPrimario, Herramientas, Pestanas, PAGINA } from '../ui/Pantalla';
import { useSwipeGesture } from '../../hooks/useSwipeGesture';
import { getTodayISO } from '../../utils/dateUtils';

// Finanzas en 3 pestañas (28-oct-2026). Antes eran 7 (Balance, Cobranza, Sueldo, Técnicos, Gastos,
// Inventario, Ajustes) y varias se pisaban:
//   · Resumen: lo que te queda en un período (7/30/60/90 días, un mes o desde–hasta), lo que falta cobrar y lo cobrado.
//   · Técnicos: lo de cada técnico (rendimiento y liquidación) y tu sueldo.
//   · Gastos y ajustes: cargar gastos; pasajes, tiempos y base.
// El inventario pasó a Productos.
const TABS = [
    { id: 'resumen',  label: 'Resumen' },
    { id: 'tecnicos', label: 'Técnicos' },
    { id: 'gastos',   label: 'Gastos y ajustes' },
];

function Sub({ items, activo, onChange }) {
    return (
        <div className="flex gap-1 p-1 rounded-xl bg-panel w-full md:w-auto">
            {items.map(([id, txt]) => (
                <button key={id} type="button" onClick={() => onChange(id)} aria-pressed={activo === id}
                    className={`flex-1 md:flex-none h-9 px-3 rounded-lg text-label font-black ${activo === id ? 'bg-ink text-page' : 'text-secondary'}`}>{txt}</button>
            ))}
        </div>
    );
}

export default function DashboardFinanzas() {
    const [tab,       setTab]       = useState('resumen');
    const [subTec,    setSubTec]    = useState('tecnicos');
    const [subGas,    setSubGas]    = useState('gastos');
    const [filtroMes, setFiltroMes] = useState(getTodayISO().slice(0, 7));
    const [modalCierre, setModalCierre] = useState(false);
    const swipeHandlers = useSwipeGesture(TABS.map(t => t.id), tab, setTab);
    const conMes = tab === 'tecnicos' || (tab === 'gastos' && subGas === 'gastos');

    return (
        <div className={PAGINA} {...swipeHandlers}>
            <div className={CONTENEDOR}>
                <PantallaHeader titulo="Finanzas" subtitulo="Lo que entró, lo que falta y lo que te queda"
                    accion={<BotonPrimario icono={LuLock} onClick={() => setModalCierre(true)}>Cierre de caja</BotonPrimario>} />

                <Pestanas items={TABS} activo={tab} onChange={setTab} />

                <Herramientas>
                    {tab === 'tecnicos' && <Sub items={[['tecnicos', 'Por técnico'], ['sueldo', 'Tu sueldo']]} activo={subTec} onChange={setSubTec} />}
                    {tab === 'gastos' && <Sub items={[['gastos', 'Gastos'], ['ajustes', 'Ajustes']]} activo={subGas} onChange={setSubGas} />}
                    {conMes && (
                        <input type="month" value={filtroMes} onChange={e => setFiltroMes(e.target.value)} aria-label="Mes"
                            className="h-9 md:h-10 px-3 rounded-xl text-label font-bold outline-none bg-transparent text-ink border border-black/10 dark:border-white/10" />
                    )}
                    {/* En celular el cierre va en esta fila, a la derecha */}
                    <button type="button" onClick={() => setModalCierre(true)}
                        className="md:hidden ml-auto h-9 px-3 shrink-0 rounded-xl inline-flex items-center gap-1.5 bg-[#C9341F] text-white text-label font-black active:scale-95">
                        <LuLock size={14} /> Cierre de caja
                    </button>
                </Herramientas>

                {tab === 'resumen'  && <TabResumen />}
                {tab === 'tecnicos' && subTec === 'tecnicos' && <TabTecnicos filtroMes={filtroMes} />}
                {tab === 'tecnicos' && subTec === 'sueldo'   && <TabSueldo filtroMes={filtroMes} setFiltroMes={setFiltroMes} />}
                {tab === 'gastos'   && subGas === 'gastos'   && <TabGastos filtroMes={filtroMes} />}
                {tab === 'gastos'   && subGas === 'ajustes'  && <TabAjustesFinanzas />}
            </div>

            {modalCierre && (
                <CierreCajaModal
                    onClose={() => setModalCierre(false)}
                    onArchivar={() => setModalCierre(false)}
                    mesInicial={filtroMes}
                />
            )}
        </div>
    );
}
